import axios from "../../config/axiosConfig";
import {
  SALES_REGISTER_REPORT_REQUEST,
  SALES_REGISTER_REPORT_SUCCESS,
  SALES_REGISTER_REPORT_FAILURE,

  GET_ACCOUNTS_OF_SALES_BILL_REQUEST,
  GET_ACCOUNTS_OF_SALES_BILL_REQUEST_FAILURE,
  GET_ACCOUNTS_OF_SALES_BILL_SUCCESS,

  GET_ITEMS_OF_SALES_BILL_REQUEST,
  GET_ITEMS_OF_SALES_BILL_REQUEST_FAILURE,
  GET_ITEMS_OF_SALES_BILL_SUCCESS,

  GET_BROKERS_OF_SALES_BILL_REQUEST,
  GET_BROKERS_OF_SALES_BILL_REQUEST_FAILURE,
  GET_BROKERS_OF_SALES_BILL_SUCCESS,

  GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST,
  GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST_FAILURE,
  GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_SUCCESS,

  GET_LOTS_OF_SALES_BILL_REQUEST,
  GET_LOTS_OF_SALES_BILL_REQUEST_FAILURE,
  GET_LOTS_OF_SALES_BILL_SUCCESS,

  SALES_REGISTER_REPORT_REQUEST_SUCCESS,
  SALES_REGISTER_REPORT_REQUEST_FAILURE
} from "../types/sales-report-types";

export const getAllAccountOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ACCOUNTS_OF_SALES_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllAccountOfSalesBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ACCOUNTS_OF_SALES_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_ACCOUNTS_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_ACCOUNTS_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllBrokersOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_BROKERS_OF_SALES_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllBrokersOfSalesBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BROKERS_OF_SALES_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_BROKERS_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_BROKERS_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllLotsOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_LOTS_OF_SALES_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllLotNoOfSalesBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_LOTS_OF_SALES_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_LOTS_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_LOTS_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllVehiclesOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllVehiclesOfSalesBill", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllItemTypesOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllItemTypesOfSalesBill", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllTransportsOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllTransportOfSalesBill", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllSalesPersonsOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllSalesPersonsOfSalesBill", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllPartyGroupsOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllPartyGroupOfSalesBill", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};


export const getAllItemsOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ITEMS_OF_SALES_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllItemsOfSalesBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ITEMS_OF_SALES_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_ITEMS_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_ITEMS_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllSaleBillInvoiceNumberOfSalesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/sales-bill/getAllSaleBillInvoiceNumberOfSalesBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_SALE_BILLS_INVOICE_NUMBER_OF_SALES_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getSalesRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType,
        selectedBills: params?.selectedBills,
        selectedParties: params?.selectedParties,
        fromDate: params?.fromDate,
        toDate: params?.toDate,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };
      const data = requestParams; 

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/sales-bill/getReportBillWise?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.post('/sales-bill/getReportBillWise', data, { params: defaultParams }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SALES_REGISTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: SALES_REGISTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: SALES_REGISTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearSalesRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: SALES_REGISTER_REPORT_SUCCESS, payload: {} });
  }
}


export const getSalesRegisterReportMailWhatsapp = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      console.log('params', params);
      
      const requestParams = { ...defaultParams, ...params };
      const data = requestParams; 

      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/sales-bill/getReportBillWise?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.post('/sales-bill/getReportBillWise', data, {
        params: defaultParams,
      }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: SALES_REGISTER_REPORT_REQUEST_SUCCESS, payload: response.data });
        }
        return response?.data;
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: SALES_REGISTER_REPORT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: SALES_REGISTER_REPORT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const sendMailSaleRegister = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_REGISTER_REPORT_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('accountId', mailData.accountId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `sales_register.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/sales-bill/sales-register-mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_REGISTER_REPORT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_REGISTER_REPORT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_REGISTER_REPORT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappSaleRegister = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: SALES_REGISTER_REPORT_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('accountId', whatsappData.accountId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      formData.append('totalAmount', whatsappData.totalAmount || 0);
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `sales_register.pdf`);
      }

      // console.log('formData>>',formData);
      
      return axios.post("/sales-bill/sales-register-whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: SALES_REGISTER_REPORT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: SALES_REGISTER_REPORT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: SALES_REGISTER_REPORT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};